<template>
    <li v-for="(item, index) in data" :key="index" :class="item.children !== undefined  && item.children.length > 0 && item.children.filter(f => f.id == category_id).length ? 'li-submenu' : ''">
        <!-- class="d-flex align-items-center justify-content-between" -->
        <template v-if="item.children !== undefined  && item.children.length > 0">
            <router-link
                :to="{'name': 'products_by_category', params: { category_id: item.id }}"
                :class="(category_id != 0 && category_id == item.id ? 'active' : '') + ' ' + (item.children !== undefined  && item.children.length > 0 && item.children.filter(f => f.id == category_id).length ? '' : 'collapsed')"
                >
            <!-- <a
                :href="item.children !== undefined  && item.children.length > 0 ? `#flush-${parent_id}.${item.id}` : ''"
                class="submenu"
                :class="item.children !== undefined  && item.children.length > 0 && item.children.filter(f => f.id == category_id).length ? '' : 'collapsed'"
            > -->
                <!-- data-bs-toggle="collapse"
                aria-expanded="false" -->
                    {{ item.translate.name }}
                    <!-- <div class='fas fa-caret-down right'></div> -->
            </router-link>

            <div
                :href="item.children !== undefined  && item.children.length > 0 ? `#flush-${parent_id}.${item.id}` : ''"
                class="menubtn"
                :class="item.children !== undefined  && item.children.length > 0 && item.children.filter(f => f.id == category_id).length ? '' : 'collapsed'"
                data-bs-toggle="collapse"
                aria-expanded="false"
            >
            </div>

        </template>
        <router-link v-else :to="{'name': 'products_by_category', params: { category_id: item.id }}" :class="category_id != 0 && category_id == item.id ? 'active' : '' ">
            {{ item.translate.name }}
        </router-link>

        <ul v-if="item.children !== undefined  && item.children.length > 0" class="collapse filter-menu-body" :id="`flush-${parent_id}.${item.id}`" :class="item.children !== undefined  && item.children.length > 0 && item.children.filter(f => f.id == category_id).length ? 'show' : ''">
            <FilterCategoryItem :data="item.children" :parent_id="item.id" :category_id="category_id" />
        </ul>
    </li>
</template>


<script>
import FilterCategoryItem from './FilterCategoryItem';

export default {
    name: "FilterCategoryItemC",
    components:{
        FilterCategoryItem,
    },
    props:{
        data: {
            type: Array,
            default: () => []
        },
        parent_id: {
            type: Number,
            default: 0
        },
        category_id: {
            type: Number,
            default: 0
        },
        lang: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        return {};
    },
}
</script>

<style lang="scss" scoped>
    .active{
        background-color: rgba(129, 79, 79, 0.8);
        border-left: 4px solid #fff;
    }
	div.menubtn{
		// width: 40px;
		// height: 40px;
        margin-top: -42px;
		float: inline-end;
		border: 1px solid rgba(179, 175, 175, 0.2);
        border-radius: 5px;
		text-align: center;
		vertical-align: middle;
        cursor: pointer;
	}
	div.menubtn.collapsed::after {
        display: flex;
        padding: 6px 14px;
		font-family: "Font Awesome 5 Free";
		font-weight: 900;
		content: "\f0d7";
		transition: var(--bs-accordion-btn-icon-transition);
	}
	div.menubtn::after{
        display: flex;
        padding: 6px 14px;
		font-family: "Font Awesome 5 Free";
		font-weight: 900;
		content: "\f0d8";
	}
</style>